import { FC, useState } from 'react';
import { isMobile } from 'react-device-detect';
import Swiper, { Pagination } from 'swiper';
import { Swiper as SwipeWrapper, SwiperSlide, useSwiper } from 'swiper/react';

import Campaign from '@/components/elements/Static/Campaign';
import ChargeCredit from '@/components/elements/Static/ChargeCredit';
import ChargeOther from '@/components/elements/Static/ChargeOther';
import WelcomeDmm from '@/components/elements/Static/WelcomeDmm';

import { Container, NavigationButton, SlideWrapper } from './style';

export enum StaticPage {
  welcomeDmm = 'WelcomeDmm', // DMM競輪にようこそ
  chargeCredit = 'ChargeCredit', // かんたんチャージ
  chargeOther = 'ChargeOther', // その他の決済方法でチャージ
  campaign = 'Campaign', // お得なキャンペーン
}

export interface PageProps {
  staticPageList: StaticPage[];
  closeModal: () => void;
}

const NavigationBtnPrev: FC<{
  slideWidth: string;
  index: number;
  hiddenIndex: number;
}> = ({ slideWidth, index, hiddenIndex }) => {
  const swiper = useSwiper();
  return (
    <>
      {index === hiddenIndex || isMobile ? (
        <></>
      ) : (
        <NavigationButton
          iconType={'prev'}
          slideWidth={slideWidth}
          onClick={() => swiper.slidePrev()}
        />
      )}
    </>
  );
};

const NavigationBtnNext: FC<{
  slideWidth: string;
  index: number;
  hiddenIndex: number;
}> = ({ slideWidth, index, hiddenIndex }) => {
  const swiper = useSwiper();
  return (
    <>
      {index === hiddenIndex || isMobile ? (
        <></>
      ) : (
        <NavigationButton
          iconType={'next'}
          slideWidth={slideWidth}
          onClick={() => swiper.slideNext()}
        />
      )}
    </>
  );
};

const PageContent: React.FC<PageProps> = ({ staticPageList, closeModal }) => {
  const [slideWidth, setSlideWidth] = useState<string>(
    `${window.outerWidth}px`,
  );
  const [activeIndex, setIActiveIndex] = useState<number>(0);
  const updateActiveIndex = (swiper: Swiper) => {
    setIActiveIndex(swiper.activeIndex);
  };

  return (
    <Container count={3}>
      <SwipeWrapper
        slidesPerView={1}
        centeredSlides={true}
        spaceBetween={8}
        loop={false}
        onSlideChange={swiper => {
          updateActiveIndex(swiper);
        }}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          375: {
            slidesPerView: 1,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 'auto',
          },
        }}
        autoplay={{
          delay: 5000,
        }}
        modules={[Pagination]}
        onResize={swiper => {
          const style = window.getComputedStyle(swiper.slides[0]);
          setSlideWidth(style.width);
        }}
      >
        {staticPageList.map(item => (
          <SwiperSlide key={item}>
            <SlideWrapper>
              {item === StaticPage.welcomeDmm ? <WelcomeDmm /> : <></>}
              {item === StaticPage.chargeCredit ? <ChargeCredit /> : <></>}
              {item === StaticPage.chargeOther ? <ChargeOther /> : <></>}
              {item === StaticPage.campaign ? (
                <Campaign closeModal={closeModal} />
              ) : (
                <></>
              )}
            </SlideWrapper>
          </SwiperSlide>
        ))}
        <NavigationBtnPrev
          slideWidth={slideWidth}
          index={activeIndex}
          hiddenIndex={0}
        />
        <NavigationBtnNext
          slideWidth={slideWidth}
          index={activeIndex}
          hiddenIndex={staticPageList.length - 1}
        />
      </SwipeWrapper>
    </Container>
  );
};

export default PageContent;
